import { API_BASE_URL, ApiEnvelope, apiClient, authHeaders } from './apiClient';
import { beginTransfer, endTransfer } from './sessionActivity';

export type DownloadTicket = {
  ticket: string;
  fileName: string;
  expiresInMs: number;
};

function downloadUrl(ticket: string) {
  return `${API_BASE_URL}/api/files/download?${new URLSearchParams({ ticket })}`;
}

/** Hidden iframe：走瀏覽器下載管理員串流寫碟，不把整檔載進 RAM。 */
function clickDownload(url: string) {
  const iframe = document.createElement('iframe');
  iframe.hidden = true;
  iframe.src = url;
  document.body.appendChild(iframe);
  window.setTimeout(() => iframe.remove(), 60_000);
}

async function issueAndSave(body: { path: string } | { paths: string[] }) {
  beginTransfer();
  try {
    const res = await apiClient.post<ApiEnvelope<DownloadTicket>>(
      '/api/files/download-ticket',
      body,
      authHeaders()
    );
    const data = res.data?.data;
    if (!res.data?.success || !data?.ticket) {
      throw new Error(res.data?.message || 'Cannot start download');
    }
    clickDownload(downloadUrl(data.ticket));
    window.setTimeout(() => endTransfer(), 60_000);
  } catch (e) {
    endTransfer();
    throw e;
  }
}

export async function startFileDownload(path: string) {
  await issueAndSave({ path });
}

export async function startZipDownload(paths: string[]) {
  await issueAndSave({ paths });
}
